module.exports = "<uch></uch>\r\n<div class=\"userContBottom\">\r\n    <div class=\"userContent\">\r\n        <qr-code></qr-code>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/qrCode/index.html
// module id = 226
// module chunks = 0